import {
  IActionsUpdateSelectedAmount,
  IActionsUpdateCustomAmount,
  IActionsTappedCategoryAccordion,
  IActionsSetSelectedSectionTags,
} from "../actions/nutritionPaneActions";

export const updateSelectedAmount = (
  selectedAmount: string
): IActionsUpdateSelectedAmount => {
  return {
    type: "UPDATE_SELECTED_AMOUNT",
    selectedAmount: selectedAmount,
  };
};

export const updateCustomAmount = (
  customAmount: number
): IActionsUpdateCustomAmount => {
  return {
    type: "UPDATE_CUSTOM_AMOUNT",
    customAmount: customAmount,
  };
};

export const tappedCategoryAccordion = (
  categoryId: string
): IActionsTappedCategoryAccordion => {
  return {
    type: "TAPPED_CATEGORY_ACCORDION",
    categoryId: categoryId,
  };
};

export const setSelectedSectionTags = (
  tagIds: string[]
): IActionsSetSelectedSectionTags => {
  return {
    type: "SET_SELECTED_SECTION_TAGS",
    tagIds: tagIds,
  };
};
